import { z } from 'zod'

export const requestDispatchSimulationAllStoresByEmailSchema = z.object({
  emails: z.array(z.email()),
  sendToPilotage: z.boolean(),
})

export type RequestDispatchSimulationAllStoresByEmailInput = z.infer<
  typeof requestDispatchSimulationAllStoresByEmailSchema
>
